<div class="modal-header">
  <h6 class="modal-title fw-semibold">เลือกประเภทการลงทะเบียน</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <div class="py-5">
    <div class="d-grid gap-4 col-xl-8 mx-auto">
      <button class="btn btn-outline-primary btn-lg" (click)="registerByMySelf()" type="button">
        ลงทะเบียนด้วยตนเอง/ผู้ปกครอง/ผู้รับรอง
      </button>
      <button class="btn btn-outline-primary btn-lg" (click)="registerByGuarantor()" type="button">
        ลงทะเบียนโดยผู้รับมอบอำนาจ
      </button>
    </div>
  </div>
  <div class="text-center text-muted">
    หมายเหตุ : กรณีลงทะเบียนแบบกลุ่มให้ใช้เมนูลงทะเบียนสำหรับกลุ่มพิเศษ ได้แก่ กรมแพทย์ทหารเรือ ทหารอากาศ
    นักศึกษาจบการศึกษา ทหารเกณฑ์ปลดประจำการ
    ผู้ต้องขังพ้นโทษ
  </div>
</div>
<!--<div class="modal-footer">-->
<!--  <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button>-->
<!--</div>-->
